import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

const getValue = (control: AbstractControl): string => {
  if (control.value === null || control.value === undefined) return '';
  return String(control.value).trim();
};

export function requiredMinMaxValidator(opts: {
  required: boolean;
  min?: number;
  max?: number;
  requiredErrorKey?: string;
}): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = getValue(control);

    if (opts.required) {
      if (!value) {
        return { [opts.requiredErrorKey || 'required']: true };
      }
    }

    if (!value) return null;

    if (opts.min !== undefined && value.length < opts.min) {
      return { minLength: { requiredMin: opts.min, actual: value.length } };
    }

    if (opts.max !== undefined && value.length > opts.max) {
      return { maxLength: { requiredMax: opts.max, actual: value.length } };
    }

    return null;
  };
}

export function fileExtensionValidator(allowedExtensions: string[], errorKey = 'fileExtension'): ValidatorFn {
  const normalizedAllowed = allowedExtensions.map((e) => e.toLowerCase().replace('.', ''));

  return (control: AbstractControl): ValidationErrors | null => {
    const file = control.value as unknown as File | null | undefined;
    if (!file) return null;

    const name = (file as any).name ? String((file as any).name) : '';
    const ext = name.includes('.') ? name.split('.').pop()!.toLowerCase() : '';

    if (!ext || !normalizedAllowed.includes(ext)) {
      return { [errorKey]: { allowed: normalizedAllowed, actual: ext } };
    }

    return null;
  };
}

export function fileSizeMaxValidator(maxBytes: number, errorKey = 'fileSizeMax'): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const file = control.value as unknown as File | null | undefined;
    if (!file) return null;

    if (file.size > maxBytes) {
      return { [errorKey]: { maxBytes, actual: file.size } };
    }

    return null;
  };
}
export function requiredCourseIdValidator(errorKey = 'courseRequired'): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = getValue(control);
    if (!value) return { [errorKey]: true };
    return null;
  };
}

export function requiredFileValidator(errorKey = 'required'): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;
    if (!value) return { [errorKey]: true };
    return null;
  };
}